import { GetCorporation } from "../hooks/useGetCorporation";
import { useNavigate } from "react-router-dom";
import backwardArrowWhite from "../assets/icons/arrow_right_detail.svg";
import reviewImage from "../assets/icons/reviewImage.svg";

export const CorporationByLocation = (
  corporations: GetCorporation["getCorporation"]["corporation"],
  index: number
) => {
  const navigate = useNavigate();
  return (
    <div
      className={`px-5 pt-3 pb-5 relative w-full flex flex-col gap-2 border-t-[1px] `}
    >
      {/* 매장 준비중  */}
      <div
        className={`w-full h-full absolute left-0 top-0 bg-black bg-opacity-30 z-10 flex items-center justify-center ${
          corporations.isActive === true ? "hidden" : ""
        }`}
      >
        <div className="text-white text-center">
          <p className="text-2xl font-bold">매장 준비중</p>
        </div>
      </div>
      {/* img  */}
      <div className="overflow-x-auto removeScroll flex flex-nowrap gap-2 w-full items-center">
        {/* 이미지는 5개만 불러오기   */}
        {corporations.goods.length > 0 &&
          corporations.goods.slice(0, 5).map((good: any, index: number) => (
            <div
              key={`img-${index}`}
              onClick={() => {
                navigate(`/coporation/${corporations.id}`);
              }}
              className={`relative rectangle 
              rounded-md cursor-pointer w-[150px] h-[150px] overflow-hidden flex-shrink-0 `}
            >
              <img
                src={good.goodPosters[0]?.upload?.url}
                alt={good.title + "사진"}
                className="w-full h-full object-cover "
              />
              z{" "}
            </div>
          ))}
        {/* 버튼  */}
        {corporations.goods.length > 5 && (
          <button
            onClick={() => {
              navigate(`/coporation/${corporations.id}`);
            }}
            className={`relative  
               w-[60px] h-[150px]  flex-shrink-0 text-center flex items-center justify-center bg-main`}
          >
            <img src={backwardArrowWhite} className="w-10 " />
          </button>
        )}
      </div>
      <div className="texts flex-1 flex flex-col gap-2">
        <div className="overflow-hidden">
          <a
            onClick={() => navigate(`/coporation/${corporations.id}`)}
            className={`ellipsis1 text-large font-bold break:text-Xlarge overflow-hidden hover:underline cursor-pointer`}
          >
            {corporations.name}
          </a>
        </div>
        <div className="flex gap-x-3 items-center">
          <span className="text-[#575757] text-xs">
            <img src={reviewImage} className="inline-block mr-1" />
            {(() => {
              const reviewCount = corporations.goods.reduce(
                (acc, curr) => acc + curr.goodReviews.length,
                0
              );
              return reviewCount >= 100
                ? "99+"
                : reviewCount.toString().padStart(2, "0");
            })()}
          </span>
          {/* 쿠폰 있을 때  */}
          {/* <span className="text-xs px-1 rounded-xl bg-green-700 text-white sparkle-coupon">
            할인쿠폰
          </span> */}
        </div>
      </div>
    </div>
  );
};
